import Checkbox3Control from './checkbox3-control.js';
import CHECKBOX_STATES from './CHECKBOX_STATES';

export 
{ 
    CHECKBOX_STATES
}
export default Checkbox3Control;
